import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i8n";
import { loadConfig } from "./utils/config";

const root = ReactDOM.createRoot(document.getElementById("root"));
await loadConfig();
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
